// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"animated-menu-icon_menuIcon__InFUl"};